import { Fragment } from 'react'
import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import { DeviceNameEdit } from './GroupDashboard'
import type { Vals } from '../../../demo/vals'

export function MemberDetail({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 20px 34px;display:flex;flex-direction:column;overflow:auto")}>
      <button onClick={v.tabGroup} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;margin-bottom:14px")}>
        <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
      </button>
      <div style={sx("display:flex;align-items:center;gap:14px;margin-bottom:20px")}>
        <span style={sx(`width:52px;height:52px;flex:none;border-radius:var(--radius-full);background:${v.memberTint};color:#fff;display:flex;align-items:center;justify-content:center;font-size:var(--fs-lg);font-weight:var(--fw-medium)`)}>
          {v.memberInitials}
        </span>
        <span style={sx("display:flex;flex-direction:column;gap:2px;min-width:0")}>
          <span style={sx("font-size:var(--fs-xl);font-weight:var(--fw-bold)")}>
            {v.memberName}
          </span>
          <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
            {v.memberEmail}
          </span>
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            {v.memberRole}
          </span>
        </span>
      </div>
      <span style={sx("font-size:var(--fs-xs);font-weight:var(--fw-medium);color:var(--text-secondary);letter-spacing:.04em;text-transform:uppercase;margin-bottom:8px")}>
        Known devices
      </span>
      <span style={sx("font-size:var(--fs-xs);line-height:17px;color:var(--text-secondary);margin-bottom:10px")}>
        {v.memberDevicesNote}
      </span>
      <div style={sx("display:flex;flex-direction:column;gap:8px;margin-bottom:16px")}>
        {v.memberDevices.map((dev, i) => (
          <Fragment key={i}>
            {v.deviceNameEditingKey === dev.renameKey ? (
              <DeviceNameEdit v={v} />
            ) : (
            <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;align-items:center;gap:12px")}>
              <span style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-md);background:var(--bg-tertiary);display:flex;align-items:center;justify-content:center")}>
                <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/phone-apple.svg) center/contain no-repeat;mask:url(/assets/icons/phone-apple.svg) center/contain no-repeat")} />
              </span>
              <Hov
                as="button"
                onClick={() => v.startDeviceName(dev.renameKey, dev.name)}
                title="Rename device"
                style={sx("flex:1;min-width:0;padding:0;border:none;background:transparent;font-family:inherit;color:var(--text-primary);text-align:left;cursor:text;display:flex;flex-direction:column;gap:2px;border-radius:var(--radius-sm)")}
                hoverStyle={sx("background:var(--bg-tertiary)")}
              >
                <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
                  {dev.name}
                </span>
                <span style={sx(`font-size:var(--fs-2xs);color:${dev.color}`)}>
                  {dev.status}
                </span>
              </Hov>
              {dev.hasBtn ? (
                <>
                  <button onClick={dev.action} style={sx(`height:30px;padding:0 12px;flex:none;border-radius:var(--radius-full);border:1px solid ${dev.btnBorder};background:${dev.btnBg};color:${dev.btnColor};font-family:inherit;font-size:var(--fs-2xs);font-weight:var(--fw-medium);cursor:pointer`)}>
                    {dev.btnLabel}
                  </button>
                </>
              ) : null}
            </div>
            )}
          </Fragment>
        ))}
      </div>
      <div style={sx("margin-top:auto;display:flex;flex-direction:column;gap:10px")}>
        <Hov as="button" onClick={v.removeMember} style={sx("height:48px;border-radius:var(--radius-full);border:1px solid var(--border-critical);background:transparent;color:var(--text-critical);font-family:inherit;font-size:var(--fs-sm);font-weight:var(--fw-medium);cursor:pointer")} hoverStyle={sx("background:var(--bg-critical-subtle)")}>
          Remove from Group
        </Hov>
        <span style={sx("font-size:var(--fs-2xs);line-height:15px;color:var(--text-secondary);text-align:center")}>
          Their account stays — it just stops being paid by you at the next renewal.
        </span>
      </div>
    </div>
  )
}
